import React, { useEffect, useState } from 'react';
import { MessageSquare, Facebook, Youtube, Shield, FileText, HelpCircle } from 'lucide-react';
type Language = 'es' | 'en' | 'pt';
const translations = {
  es: {
    description: 'La experiencia definitiva de servidor privado de MU Online. Únete a miles de jugadores en batallas épicas, conquista el castillo y conviértete en una leyenda.',
    quickLinks: 'Enlaces Rápidos',
    home: 'Inicio',
    register: 'Registrarse',
    download: 'Descargar',
    rankings: 'Rankings',
    webMarket: 'Mercado Web',
    support: 'Soporte',
    termsOfService: 'Términos de Servicio',
    privacyPolicy: 'Política de Privacidad',
    supportCenter: 'Centro de Soporte',
    allRightsReserved: 'Todos los derechos reservados.',
    disclaimer: 'MU Online es una marca registrada de Webzen Inc. No estamos afiliados con Webzen.'
  },
  en: {
    description: 'The ultimate MU Online private server experience. Join thousands of players in epic battles, conquer the castle, and become a legend.',
    quickLinks: 'Quick Links',
    home: 'Home',
    register: 'Register',
    download: 'Download',
    rankings: 'Rankings',
    webMarket: 'Web Market',
    support: 'Support',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    supportCenter: 'Support Center',
    allRightsReserved: 'All rights reserved.',
    disclaimer: 'MU Online is a registered trademark of Webzen Inc. We are not affiliated with Webzen.'
  },
  pt: {
    description: 'A experiência definitiva de servidor privado de MU Online. Junte-se a milhares de jogadores em batalhas épicas, conquiste o castelo e torne-se uma lenda.',
    quickLinks: 'Links Rápidos',
    home: 'Início',
    register: 'Registrar',
    download: 'Baixar',
    rankings: 'Rankings',
    webMarket: 'Mercado Web',
    support: 'Suporte',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    supportCenter: 'Centro de Suporte',
    allRightsReserved: 'Todos os direitos reservados.',
    disclaimer: 'MU Online é uma marca registrada da Webzen Inc. Não somos afiliados à Webzen.'
  }
};
export function Footer() {
  const [language, setLanguage] = useState<Language>('es');
  const t = translations[language];
  useEffect(() => {
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang) setLanguage(savedLang);
    const handleLanguageChange = (e: CustomEvent<Language>) => {
      setLanguage(e.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => window.removeEventListener('languageChange', handleLanguageChange as EventListener);
  }, []);
  return <footer className="bg-[#03060a] border-t border-white/10 pt-16 pb-8 relative z-10" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-108">
          {/* Brand Col */}
          <div className="md:col-span-2" data-id="element-109">
            <a href="#home" className="flex items-center gap-3 mb-6" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/npdMkBLoRCeQarTgcKB5ee/ChatGPT_Image_Mar_25,_2026,_10_14_36_AM.png" alt="MU Vanguard Logo" className="h-16 w-auto object-contain" data-id="element-111" />
              <div className="flex flex-col" data-id="element-112">
                <span className="font-cinzel font-bold text-2xl text-gradient-gold leading-none" data-id="element-113">
                  Vanguard
                </span>
                <span className="text-xs text-gray-400 tracking-widest uppercase mt-1" data-id="element-114">
                  Season 6
                </span>
              </div>
            </a>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-115">{t.description}</p>
            <div className="flex gap-4" data-id="element-116">
              <a href="#" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#5865F2] hover:border-[#5865F2] transition-colors" data-id="element-117">
                <MessageSquare className="w-5 h-5" data-id="element-118" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#1877F2] hover:border-[#1877F2] transition-colors" data-id="element-119">
                <Facebook className="w-5 h-5" data-id="element-120" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-darkBlue border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#FF0000] hover:border-[#FF0000] transition-colors" data-id="element-121">
                <Youtube className="w-5 h-5" data-id="element-122" />
              </a>
            </div>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-123">
            <h4 className="font-cinzel font-bold text-white mb-6 text-lg" data-id="element-124">
              {t.quickLinks}
            </h4>
            <ul className="space-y-3" data-id="element-125">
              <li data-id="element-126">
                <a href="#home" className="text-gray-400 hover:text-gold transition-colors" data-id="element-127">
                  {t.home}
                </a>
              </li>
              <li data-id="element-128">
                <a href="#register" className="text-gray-400 hover:text-gold transition-colors" data-id="element-129">
                  {t.register}
                </a>
              </li>
              <li data-id="element-130">
                <a href="#download" className="text-gray-400 hover:text-gold transition-colors" data-id="element-131">
                  {t.download}
                </a>
              </li>
              <li data-id="element-132">
                <a href="#rankings" className="text-gray-400 hover:text-gold transition-colors" data-id="element-133">
                  {t.rankings}
                </a>
              </li>
              <li data-id="element-134">
                <a href="#market" className="text-gray-400 hover:text-gold transition-colors" data-id="element-135">
                  {t.webMarket}
                </a>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-136">
            <h4 className="font-cinzel font-bold text-white mb-6 text-lg" data-id="element-137">
              {t.support}
            </h4>
            <ul className="space-y-3" data-id="element-138">
              <li data-id="element-139">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-140">
                  <Shield className="w-4 h-4" data-id="element-141" /> {t.termsOfService}
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-143">
                  <FileText className="w-4 h-4" data-id="element-144" /> {t.privacyPolicy}
                </a>
              </li>
              <li data-id="element-145">
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2" data-id="element-146">
                  <HelpCircle className="w-4 h-4" data-id="element-147" /> {t.supportCenter}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-148">
          <p className="text-sm text-gray-500" data-id="element-149">
            &copy; {new Date().getFullYear()} MU Vanguard. {t.allRightsReserved}
          </p>
          <p className="text-xs text-gray-600" data-id="element-150">{t.disclaimer}</p>
        </div>
      </div>
    </footer>;
}